import React from "react";

import { templates } from "@reactivated";

import { DistanceToFlagshipStoreSSR } from "../apps/retail-locator/DistanceToFlagshipStoreSSR";

export const Template = (
    props: templates.DistanceToFlagshipStoreTemplate,
): React.JSX.Element => {
    return <DistanceToFlagshipStoreSSR {...props} />;
};
